import { useState } from "react";
import { Link } from "react-router-dom";
import { TrendingUp, Lock, Mail, User, Phone, CheckCircle2, Building2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import api, { errMsg } from "@/lib/api";
import { SalesBackground } from "@/components/SalesBackground";

const Fld = ({ Icon, ...p }) => (
  <div className="relative">
    <Icon className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
    <Input className="h-11 pl-10 bg-white" {...p} />
  </div>
);

export default function Register() {
  const [f, setF] = useState({ company_name: "", name: "", email: "", phone: "", password: "", confirm: "" });
  const [error, setError] = useState("");
  const [done, setDone] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (f.password !== f.confirm) return setError("Konfirmasi password tidak sama");
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/register", { company_name: f.company_name, name: f.name, email: f.email, phone: f.phone, password: f.password });
      setDone(data.message);
    } catch (er) {
      setError(errMsg(er));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center p-6">
      <SalesBackground />
      <div className="card-premium relative z-10 w-full max-w-md p-10 fade-up" data-testid="register-card">
        <div className="mb-6 flex items-center gap-2.5">
          <div className="grid h-10 w-10 place-items-center rounded-xl bg-gradient-to-br from-[#1E3A8A] to-[#0F172A] text-white"><TrendingUp className="h-5 w-5" /></div>
          <p className="font-heading text-xl font-bold">JLY<span className="text-[#0284C7]">sales</span></p>
        </div>
        {done ? (
          <div className="text-center" data-testid="register-success">
            <CheckCircle2 className="mx-auto h-14 w-14 text-emerald-600" />
            <p className="font-heading mt-4 text-2xl font-bold">Pendaftaran Terkirim</p>
            <p className="mt-2 text-sm text-slate-500">{done}</p>
            <Link to="/login"><Button className="mt-6 w-full h-11" data-testid="register-back-login-btn">Kembali ke Login</Button></Link>
          </div>
        ) : (
          <form onSubmit={submit} data-testid="register-form">
            <p className="font-heading text-3xl font-bold">Daftar Akun</p>
            <p className="mt-1 mb-6 text-sm text-slate-500">Pendaftaran membuat <b>PT baru</b> dengan Anda sebagai <b>Admin</b>. Akun aktif setelah disetujui Super Admin. Admin PT dapat menambah pengguna Sales di menu Users.</p>
            <div className="space-y-3.5">
              <Fld Icon={Building2} placeholder="Nama PT / Perusahaan" value={f.company_name} onChange={set("company_name")} required data-testid="register-company-input" />
              <Fld Icon={User} placeholder="Nama lengkap" value={f.name} onChange={set("name")} required data-testid="register-name-input" />
              <Fld Icon={Mail} type="email" placeholder="Email" value={f.email} onChange={set("email")} required data-testid="register-email-input" />
              <Fld Icon={Phone} placeholder="No. HP (opsional)" value={f.phone} onChange={set("phone")} data-testid="register-phone-input" />
              <Fld Icon={Lock} type="password" placeholder="Password (min. 6 karakter)" value={f.password} onChange={set("password")} required data-testid="register-password-input" />
              <Fld Icon={Lock} type="password" placeholder="Ulangi password" value={f.confirm} onChange={set("confirm")} required data-testid="register-confirm-input" />
              {error && <p className="rounded-md bg-rose-50 p-2.5 text-sm text-rose-700" data-testid="register-error">{error}</p>}
              <Button type="submit" className="h-11 w-full text-base" disabled={busy} data-testid="register-submit-btn">{busy ? "Memproses..." : "Daftar"}</Button>
            </div>
            <p className="mt-6 text-center text-sm text-slate-500">Sudah punya akun? <Link to="/login" className="font-semibold text-blue-800 hover:underline" data-testid="register-login-link">Masuk</Link></p>
          </form>
        )}
      </div>
    </div>
  );
}
